export default __webpack_public_path__ + "static/media/Premios SUME Vía Magna (1).3613f8e3.pdf";